<template>
    <div>
        <div class="marginCenter">
            <div class="marginBom30 marginTop30 navTitle flex-yCenter flex-sb">
                <div class="left flex">
                    <div class="line"></div>
                    <span>院内报到</span>
                </div>
            </div>
            <div class="query marginBom24">
                <el-form inline class="demo-form-inline">
                    <el-form-item label="进修记录">
                        <el-select v-model="applyId" placeholder="请选择进修记录" style="width: 420px">
                            <el-option
                                v-for="apply in applyList"
                                :key="apply.applyId"
                                :label="
                                    selectDictLabel(dict.type.train_type, apply.trainType) +
                                    '（' +
                                    apply.applyBasic.trainBeginDate +
                                    '~' +
                                    apply.applyBasic.trainEndDate +
                                    '）'
                                "
                                :value="apply.applyId"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-button
                        class="fr blueBtn1"
                        style="width: 140px; height: 40px"
                        type="primary"
                        @click="getTableData"
                        >查询</el-button
                    >
                </el-form>
            </div>
            <el-table
                :data="tableData"
                border
                ref="table"
                style="width: 100%"
                v-loading="loading"
                :header-cell-style="{ backgroundColor: '#f5f5f5' }"
            >
                <el-table-column prop="date" min-width="159" label="进修类型" align="center">
                    <span slot-scope="scope">{{
                        dict.type.train_type.filter((item) => item.value == scope.row.trainType)[0].label
                    }}</span>
                </el-table-column>
                <el-table-column prop="applyTime" min-width="220" label="进修申请时间" align="center">
                </el-table-column>
                <el-table-column prop="registrationDate" label="报到时间" align="center" min-width="213">
                </el-table-column>
                <el-table-column
                    v-for="(item, index) in admissionNodeList"
                    :key="index"
                    prop="groupUpdateTime"
                    :label="item.nodeName"
                    align="center"
                    min-width="150"
                    ><template slot-scope="scope">
                        <!-- 无需确认 -->
                        <span
                            v-if="item.nodeType === '0'"
                            :class="item.nodeStatus != -1 ? 'pointer fcolor_green' : ''"
                            @click="
                                item.nodeStatus != -1
                                    ? $router.push({
                                          path: '/leave/detail',
                                          query: {
                                              applyId: scope.row.applyId,
                                              nodeKey: item.nodeKey,
                                              state: 0,
                                              type: 1,
                                              nodeId: item.nodeId,
                                              nodeName: item.nodeName,
                                              operationType: 0,
                                              dept: JSON.stringify(scope.row.applyDeptList[0])
                                          }
                                      })
                                    : false
                            "
                            >无需确认</span
                        >
                        <!-- 确认 -->
                        <span v-else-if="item.nodeType === '2'">
                            <span
                                v-if="item.nodeStatus != 1"
                                :class="item.nodeStatus != -1 ? 'pointer fcolor_green' : ''"
                                @click="
                                    item.nodeStatus != -1
                                        ? $router.push({
                                              path: '/leave/detail',
                                              query: {
                                                  applyId: scope.row.applyId,
                                                  nodeKey: item.nodeKey,
                                                  state: 0,
                                                  type: 1,
                                                  nodeId: item.nodeId,
                                                  nodeName: item.nodeName,
                                                  operationType: 2,
                                                  dept: JSON.stringify(scope.row.applyDeptList[0])
                                              }
                                          })
                                        : false
                                "
                                >未确认</span
                            >
                            <span
                                v-else
                                :class="item.nodeStatus != -1 ? 'pointer fcolor_green' : ''"
                                @click="
                                    item.nodeStatus != -1
                                        ? $router.push({
                                              path: '/leave/detail',
                                              query: {
                                                  applyId: scope.row.applyId,
                                                  nodeKey: item.nodeKey,
                                                  state: 1,
                                                  type: 1,
                                                  nodeId: item.nodeId,
                                                  nodeName: item.nodeName,
                                                  operationType: 4,
                                                  dept: JSON.stringify(scope.row.applyDeptList[0])
                                              }
                                          })
                                        : false
                                "
                                >已确认</span
                            >
                        </span>
                        <!-- 上传凭证 -->
                        <span v-else>
                            <span
                                v-if="item.nodeStatus != 1"
                                :class="item.nodeStatus != -1 ? 'pointer fcolor_green' : ''"
                                @click="
                                    item.nodeStatus != -1
                                        ? $router.push({
                                              path: '/leave/detail',
                                              query: {
                                                  applyId: scope.row.applyId,
                                                  nodeKey: item.nodeKey,
                                                  state: 0,
                                                  type: 1,
                                                  nodeId: item.nodeId,
                                                  nodeName: item.nodeName,
                                                  operationType: 1,
                                                  dept: JSON.stringify(scope.row.applyDeptList[0])
                                              }
                                          })
                                        : false
                                "
                                >上传凭证</span
                            >
                            <span
                                v-else
                                :class="item.nodeStatus != -1 ? 'pointer fcolor_green' : ''"
                                @click="
                                    item.nodeStatus != -1
                                        ? $router.push({
                                              path: '/leave/detail',
                                              query: {
                                                  applyId: scope.row.applyId,
                                                  nodeKey: item.nodeKey,
                                                  state: 1,
                                                  type: 1,
                                                  nodeId: item.nodeId,
                                                  nodeName: item.nodeName,
                                                  operationType: 3,
                                                  dept: JSON.stringify(scope.row.applyDeptList[0])
                                              }
                                          })
                                        : false
                                "
                                >已上传</span
                            >
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import { trainApplySelectApplyList, trainApplyDetail, confirmRegistration, videoList } from '@/utils/api';
import { selectDictLabel } from '@/utils/ruoyi';

export default {
    dicts: ['train_type'],
    components: {},
    data() {
        return {
            typeList: [],
            form: {
                date: [],
                reviewStatus: 1,
                // registrationProcFlag : 1,
                archivesStatus: 0,
                params: {}
            },
            applyId: undefined,
            applyList: [],
            tableData: [],
            admissionNodeList: [],
            loading: false
        };
    },
    created() {
        this.getApplyList();
    },
    methods: {
        selectDictLabel,
        getApplyList() {
            this.loading = true;
            trainApplySelectApplyList(this.form)
                .then((res) => {
                    this.applyList = res.data;
                    if (this.applyList.length > 0) {
                        const applyId = this.$route.query.applyId;
                        this.applyId = applyId ? applyId + '' : this.applyList[0].applyId;
                    }
                    this.getTableData();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        async getTableData() {
            if (!this.applyId) {
                return;
            }
            this.loading = true;
            trainApplyDetail(this.applyId)
                .then((detail) => {
                    this.tableData = [detail.data];
                    this.admissionNodeList = detail.data.admissionNodeList;
                    this.$nextTick(() => {
                        this.$refs.table.doLayout();
                    });
                    if (detail.data.registrationStatus == 0) {
                        videoList({ applyId: this.applyId }).then((videoListObj) => {
                            let list = detail.data.admissionNodeList.filter((item) => item.nodeType != 0);
                            if (
                                list.every((item) => item.nodeStatus == 1) &&
                                detail.data.trainStatus != 2 &&
                                videoListObj.rows.every((item) => item.videoStatus == 1)
                            ) {
                                confirmRegistration(this.applyId);
                            }
                        });
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        link() {
            this.$router.push({
                path: '/report/certificate'
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.query {
    padding: 20px;
    // height: 50px;
    background-color: #f5f5f5;
    .el-form-item {
        margin-bottom: 0;
    }
    .line {
        text-align: center;
    }
}
.col {
    color: #1890ff;
    cursor: pointer;
}
</style>
